import GOOGLE_DRIVE from "./googleDrive.scope";

export const ScopeRegistry = {
  GOOGLE_DRIVE,
};
